module.exports = __webpack_public_path__ + "fonts/VetoSans-Bold.4c544a4b.woff";